import { render, staticRenderFns } from "./PublisherUsers.vue?vue&type=template&id=535e3826"
import script from "./PublisherUsers.vue?vue&type=script&lang=js"
export * from "./PublisherUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports